import { render, staticRenderFns } from "./ShowDetailedScope.vue?vue&type=template&id=3f8ff092"
import script from "./ShowDetailedScope.vue?vue&type=script&lang=js"
export * from "./ShowDetailedScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports